<div *ngIf="!assessCases && !hasNoCases">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="assessCases || hasNoCases">
  <clients-nside-io-home-overview [buildingId]='buildingId' [assessCases]='assessCases' [hasNoCases]='hasNoCases'>
  </clients-nside-io-home-overview>
</div>
